export enum BackgroundColorPalette {
    Blue = 0,
    Purple,
    Orange,
    Red,
    Green,
    Error
}

export const BackgroundColorMap: { [key: number]: string } = {
    [BackgroundColorPalette.Blue]: 'bg-color-person',
    [BackgroundColorPalette.Purple]: 'bg-color-primary-link-hover',
    [BackgroundColorPalette.Orange]: 'bg-color-job-300',
    [BackgroundColorPalette.Red]: 'bg-color-danger-400',
    [BackgroundColorPalette.Green]: 'bg-color-success',
    [BackgroundColorPalette.Error]: 'bg-pill-error'
};

// TEMP FIX (Hopefully) For Relocationo of Color Palette Picker back into Design
export const DotsColorMap: { [key: number]: string } = {
    [BackgroundColorPalette.Blue]: '#C3DBE7',
    [BackgroundColorPalette.Purple]: '#D0B1F3',
    [BackgroundColorPalette.Orange]: '#ECC0A7',
    [BackgroundColorPalette.Red]: '#EEBFC7',
    [BackgroundColorPalette.Green]: '#BADBB9',
    [BackgroundColorPalette.Error]: 'red'
};

export const defaultPaletteColor = BackgroundColorPalette.Blue;
